import PageHeader from "../components/PageHeader";
import HireFrontendDeveloperContent from "../components/HireFrontendDevelopers-Content";

const HireFrontendDevelopers = () => {
    return (
        <>
            <PageHeader pagetitle="Frontend Developer" breadcrumbMenu="Home" breadcrumbMenuActive="Frontend Developer" image="/images/front-end-developer-banner.jpg" />
            <HireFrontendDeveloperContent />
        </>
    )
}

export default HireFrontendDevelopers;